import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from '../../api/api';
 
const normalizeIsoDate = (value) => {
  if (!value) return null;
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};
 
const isSameFreemiumReport = (a = {}, b = {}) => {
  if (!a || !b) return false;
 
  const sameImo = a.imo_number && b.imo_number && a.imo_number === b.imo_number;
  if (!sameImo) return false;
 
  const createdAtA = normalizeIsoDate(a.created_at);
  const createdAtB = normalizeIsoDate(b.created_at);
  if (createdAtA && createdAtB && createdAtA === createdAtB) {
    return true;
  }
 
  const startA = normalizeIsoDate(a.voyage_start_date);
  const startB = normalizeIsoDate(b.voyage_start_date);
  const endA = normalizeIsoDate(a.voyage_end_date);
  const endB = normalizeIsoDate(b.voyage_end_date);
 
  if (startA && startB && endA && endB && startA === startB && endA === endB) {
    return true;
  }
 
  if (typeof a.total_eua === 'number' && typeof b.total_eua === 'number' && a.total_eua === b.total_eua) {
    return true;
  }
 
  return false;
};
 
const pickFirstNonEmpty = (...values) => {
  for (const value of values) {
    if (value !== undefined && value !== null && value !== '') {
      return value;
    }
  }
  return undefined;
};

export const fetchVesselMetaInfo = createAsyncThunk(
  "voyage/fetchVesselMetaInfo",
  async (imo_number, { rejectWithValue }) => {
    try {
      const response = await makeRequest(
        "get",
        `v2/home/get_meta_info_for_vessel/?imo_number=${imo_number}`
      );

      return response.data?.data?.[0] || null;

    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        "Failed to fetch vessel meta info"
      );
    }
  }
);

 
export const fetchVoyages = createAsyncThunk('voyages/fetchVoyages', async (params) => {
  try {
    const response = await makeRequest("get", `v2/voyage/get_voyage/?casper_id=${params.casper_id}&requested_tab=${params.requested_tab}&requested_page=${params.page}`)
    return response.data.data;
  } catch (error) {
    throw error;
  }
});
export const fetchPortList = createAsyncThunk('voyages/fetchPortList', async (page) => {
  try {
    const response = await makeRequest("get", `/freemium/port_list/?port_name=${page}`)
    return response.data.data;
  } catch (error) {
    throw error;
  }
});
export const fetchPortList2 = createAsyncThunk('voyages/fetchPortList', async (page) => {
  try {
    const response = await makeRequest("get", `/freemium/port_list/?port_name=${page}&requested_type=port_distance`)
    return response.data.data;
  } catch (error) {
    throw error;
  }
});
export const fetchFreemiumReportData = createAsyncThunk('voyages/fetchFreemiumReportList', async () => {
  try {
    const response = await makeRequest("get", `/v2/home/get_historic_report/`)
    return response.data.data;
  } catch (error) {
    throw error;
  }
});
export const fetchFuelList = createAsyncThunk('voyages/fetchFuelList', async () => {
  try {
    const response = await makeRequest("get", `/api/fuel_list`)
    return response.data.data;
  } catch (error) {
    throw error;
  }
});
 
export const searchVoyages = createAsyncThunk('voyages/searchVoyages', async (params) => {
  const { page, voyage_number, imo_number } = params
  try {
    const response = await makeRequest("get", `api/get_voyage/?requested_page=${page}&imo_number=${imo_number}&voyage_number=${voyage_number}`)
    return response.data.data;
  } catch (error) {
    throw error;
  }
});
 
 
export const fetchOffHireData = createAsyncThunk('voyages/offhireData', async (params) => {
  const { casper_id, imo_number } = params
  try {
    const response = await makeRequest("get", `/v2/home/get_fuel_for_offhire/?casper_id=${casper_id}&imo_number=${imo_number}`)
    return response.data.data;
  } catch (error) {
    throw error;
  }
});
 
export const fetchVoyagesHistory = createAsyncThunk(
  'voyage/getHistory',
  async (params) => {
    const { imo_number, page } = params
    const request = await makeRequest("get", `v2/voyage/get_voyage_history/?requested_page=${page}&imo_number=${imo_number}`)
    const response = await request.data.data
    return response
  }
)
 
export const fetchEuaDifferenceChart = createAsyncThunk(
  'voyage/euaDifferenceChart',
  async (params) => {
    const { casper_id, imo_number } = params
    const request = await makeRequest("get", `v2/voyage/get_eua_difference_chart_data/?caper_id=${casper_id}&imo_number=${imo_number}`)
    const response = await request.data.data
    return response
  }
)
 
 
export const fetchEuaDistribution = createAsyncThunk(
  'voyage/euaDistributionChart',
  async (params) => {
    const { casper_id, imo_number } = params
    const request = await makeRequest("get", `v2/voyage/get_eua_distribution/?casper_id=${casper_id}&imo_number=${imo_number}`)
    const response = await request.data.data
    return response
  }
)
 
 
export const fetchVoyageEuaOverview = createAsyncThunk(
  'voyage/euaOverview',
  async (params) => {
    const { casper_id, imo_number } = params
    const request = await makeRequest("get", `v2/voyage/get_voyage_eua_overview/?casper_id=${casper_id}&imo_number=${imo_number}`)
    const response = await request.data.data
    return response
  }
)
 
 
export const updateSelectedVoayage = createAsyncThunk(
  'voyage/updateSelectedVoyage',
  async (params) => {
    const { casper_id, imo_number } = params
    const request = await makeRequest("get", `v2/voyage/get_voyage/?casper_id=${casper_id}&imo_number=${imo_number}`)
    const response = await request.data.data[0]
    return response
  }
)
 
export const fetchStatementDocument = createAsyncThunk(
  "voyage/generateStatementDocument",
  async (params, date) => {
    const { casper_id, imo_number, start_date, end_date } = params
    const request = await makeRequest("get", `v2/home/generate_document/?casper_id=${casper_id}&imo_number=${imo_number}&doc_type=statement&start_date=${start_date}&end_date=${end_date}`)
    const response = await request.data.data
    return response
  }
)
 
export const fetchInvoice = createAsyncThunk(
  "voyage/generateInvoice",
  async (params) => {
    const { casper_id, imo_number } = params
    const request = await makeRequest("get", `v2/home/generate_document/?casper_id=${casper_id}&imo_number=${imo_number}&doc_type=invoice`)
    const response = await request.data.data
    return response
  }
)
 
export const fetchPrefilledOrderDetails = createAsyncThunk(
  "voyage/fetchOrder",
  async (params) => {
    const { imo_number } = params
    const request = await makeRequest("get", `v2/home/get_prefilled_trade_order_data/?imo_number=${imo_number}`)
    const response = await request.data.data
    return response
  }
)
 
export const fetchHistoryOrderDetails = createAsyncThunk(
  "voyage/fetchHistoryOrder",
  async (params) => {
    const { imo_number } = params
    const request = await makeRequest("get", `v2/home/get_trade_order_history/?imo_number=${imo_number}`)
    const response = await request.data.data
    return response
  }
)
 
export const postOrderDetails = createAsyncThunk(
  "voyage/postOrder",
  async (params) => {
    const request = await makeRequest("post", `v2/home/post_trade_order/`, params)
    const response = await request.data.data
    return response
  }
)
export const deleteVoyageDetails = createAsyncThunk(
  "voyage/deleteVoyage",
  async (params) => {
    const { voyage_number, imo_number } = params
    const request = await makeRequest("delete", `super_admin/delete_off_hire/?imo_number=${imo_number}&voyage_number=${voyage_number}`)
    const response = await request.data.data
    return response
  }
)

export const delete_estimation_handler = createAsyncThunk(
  `v2/home/delete_estimation_handler/`,
  async (params) => {
    const { report_id } = params
    const request = await makeRequest("delete", `v2/home/delete_estimation_handler/?report_id=${report_id}`)
    const response = await request.data.data
    return response
  }
)
 
export const uploadDocument = createAsyncThunk(
  "voyage/uploadDocument",
  async (params) => {
    const request = await makeRequest("post", `super_admin/upload_verified_statement/`, params)
    const response = await request.data.data
    return response
  }
)
export const deleteDocument = createAsyncThunk(
  "voyage/deleteDocument",
  async (params) => {
    const { voyage_number, imo_number } = params
    const request = await makeRequest("post", `api/del_verified_emission_rep/`, params)
    const response = await request.data.data
    return response
  }
)
 
 
export const postOffHireRequest = createAsyncThunk(
  'voyage/offhireRequest',
  async (params) => {
    try {
      const response = await makeRequest("patch", `v2/home/post_offhire_by_casper/`,
        params
      );
 
      return response.data.data;
    } catch (error) {
      throw new Error("Failed to update voyage");
    }
  }
);
 
export const postEuaCalculateRequest = createAsyncThunk(
  'voyage/euaCalculateRequest',
  async (params, { rejectWithValue }) => {
    try {
      const response = await makeRequest(
        "post",
        `v2/home/post_estimation_by_casper/`,
        params
      );
 
      return response.data?.data || response.data;
 
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        "Failed to calculate EUA"
      );
    }
  }
);
 
 
 
export const postFuelBlendEstimation = createAsyncThunk(
  'voyage/fuelBlendEstimation',
  async (payload) => {
    console.log(payload)
    try {
      const response = await makeRequest("post", `v2/home/post_fuel_blend_estimation/`,
        payload
      );
      // console.log(response.data.data)
      return response.data.data;
 
    } catch (error) {
      throw new Error("Failed to calcualte eua");
    }
  }
);
 
 
 
export const uploadInvoiceDoc = createAsyncThunk(
  'voyage/uploadInvoiceDoc',
  async (params) => {
    // console.log(finalData)
    try {
      const response = await makeRequest("patch", `v2/home/upload_invoice/?imo_number=${params.imo_number}&trade_order_number=${params.trade_order_number}`,
        params.file
      );
      console.log(response.data.data)
      return response.data.data;
 
    } catch (error) {
      throw new Error("Failed to Upload");
    }
  }
);
 
export const deleteInvoiceDoc = createAsyncThunk(
  'voyage/deleteInvoiceDoc',
  async (params) => {
    // console.log(finalData)
    try {
      const response = await makeRequest("patch", `v2/home/delete_invoice/?imo_number=${params.imo_number}&trade_order_number=${params.trade_order_number}`);
      console.log(response.data.data)
      return response.data.data;
 
    } catch (error) {
      throw new Error("Failed to Upload");
    }
  }
);
 
export const getFuelMetaData = createAsyncThunk(
  'voyage/getFuelMetaData',
  async (params) => {
    const encodedFuelName = encodeURIComponent(params);
    try {
      const response = await makeRequest("get", `v2/home/get_fuel_metadata_for_estimation/?fuel_name=${encodedFuelName}`);
      console.log(response.data.data)
      return response.data.data;
 
    } catch (error) {
      throw new Error("Failed to Upload");
    }
  }
);
 
const VoyageSlice = createSlice({
  name: 'voyage',
  initialState: {
    voyages: [],
    voyagesWholeData: {},
    vesselMetaInfo: null,
    status: 'idle',
    selectedVoyage: null,
    page: 1,
    euaOverview: null,
    euaDistribution: null,
    euaDifference: null,
    fuelList: [],
    historyVoyages: {
      data: [],
      error: null,
      page: 1,
      status: "idle"
      

    },
    statementDocument: null,
    downloadDocument: null,
    invoice: null,
    order: null,
    orderHistory: null,
    historyVoyagesSelected: false,
    offHireData: null,
    freemiumReportData: [],
    error: null,
    fuelMetaData: {},
    blendFactor: {}
  },
  reducers: {
    selectVoyage: (state, action) => {
      state.selectedVoyage = action.payload
      state.historyVoyages = {
        data: [],
        fuelList: null,
        error: null,
        page: 1,
        status: "idle"
      }
 
      console.log(action.payload)
    },
    clearVoyages: (state, action) => {
      state.page = 1;
      state.voyages = [];
      state.voyagesWholeData = {};
    }
  },
  extraReducers: (builder) => {
    builder

    .addCase(fetchVesselMetaInfo.fulfilled, (state, action) => {
  state.vesselMetaInfo = action.payload;
})
.addCase(fetchVesselMetaInfo.rejected, (state) => {
  state.vesselMetaInfo = null;
})

      .addCase(fetchVoyages.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchVoyages.fulfilled, (state, action) => {
        state.status = 'succeeded';
        // console.log(action);
        const requestedTab = action.meta.arg.requested_tab;
 
        if (requestedTab === "" && action.meta.arg.casper_id === "" && action.meta.arg.page === 1) {
          state.voyagesWholeData = action.payload.reduce((acc, item) => {
            if (!acc[item?.casper_id]) {
              acc[item?.casper_id] = {
                general: [],
                fuel: {}
              };
            }
            acc[item?.casper_id].general = item;
            return acc;
          }, {});
        } else if (requestedTab === "" && action.meta.arg.casper_id !== "") {
          state.voyagesWholeData = action.payload.reduce((acc, item) => {
            if (!acc[item?.casper_id]) {
              acc[item?.casper_id] = {
                general: [],
                fuel: {}
              };
            }
            acc[item?.casper_id].general = item;
            return acc;
          }, {});
        } else if (requestedTab === "fuel") {
          console.log(state.voyagesWholeData)
          state.voyagesWholeData = {
            ...state.voyagesWholeData,
            [action.meta.arg.casper_id]: {
              ...state.voyagesWholeData[action.meta.arg.casper_id],
              fuel: action.payload || {},
            },
          };
        }
 
        // Expand the voyages array with the new data
        if (action.payload[0] && requestedTab === "") {
          state.voyages = [...state.voyages, ...action.payload];
        }
        // console.log(state.voyages)
        // console.log(state.voyagesWholeData)
 
        // Increment the pagination
        console.log(action.payload)
        if (action.payload[0]) {
 
          state.page++;
        }
      })
 
      .addCase(fetchVoyages.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchVoyagesHistory.pending, (state) => {
        state.historyVoyages.status = 'loading';
      })
      .addCase(fetchVoyagesHistory.fulfilled, (state, action) => {
        state.historyVoyages.status = 'succeeded';
        state.historyVoyages.data = [...action.payload, ...state.historyVoyages.data];
        state.historyVoyages.page++
      })
      .addCase(fetchVoyagesHistory.rejected, (state, action) => {
        state.historyVoyages.status = 'failed';
        state.historyVoyages.error = action.error.message;
      })
      .addCase(fetchVoyageEuaOverview.fulfilled, (state, action) => {
        state.euaOverview = action.payload
        state.downloadDocument = action.payload?.url_verified_statement_uploaded_by_admin
      })
      .addCase(fetchEuaDifferenceChart.pending, (state, action) => {
        // console.log(action.payload)
        state.euaDifference = null
      })
      .addCase(fetchEuaDifferenceChart.fulfilled, (state, action) => {
        console.log(action.payload)
        if (action.payload == null) {
          state.euaDifference = []
        } else {
          state.euaDifference = []
          // state.euaDifference = action.payload
        }
 
      })
      .addCase(fetchEuaDistribution.fulfilled, (state, action) => {
        state.euaDistribution = action.payload
      })
      .addCase(updateSelectedVoayage.fulfilled, (state, action) => {
        state.selectedVoyage = action.payload
 
        if (!state.voyagesWholeData[action.payload.casper_id]) {
          state.voyagesWholeData[action.payload.casper_id] = {
            general: action.payload,
            fuel: {}
          };
        }
      })
      .addCase(searchVoyages.fulfilled, (state, action) => {
        state.historyVoyages.data = []
        state.page = 1
        state.voyages = action.payload
        state.selectedVoyage = action.payload[0]
        state.historyVoyages.page = 1
      })
      .addCase(fetchStatementDocument.fulfilled, (state, action) => {
        state.statementDocument = action.payload
      })
      .addCase(fetchStatementDocument.rejected, (state, action) => {
        state.statementDocument = null
      })
      .addCase(fetchInvoice.fulfilled, (state, action) => {
        state.invoice = action.payload
      })
      .addCase(fetchInvoice.rejected, (state, action) => {
        state.invoice = null
      })
      .addCase(fetchPrefilledOrderDetails.fulfilled, (state, action) => {
        state.order = action.payload
      })
      .addCase(fetchPrefilledOrderDetails.rejected, (state, action) => {
        state.order = {}
      })
      .addCase(fetchHistoryOrderDetails.fulfilled, (state, action) => {
        state.orderHistory = action.payload
      })
      .addCase(fetchHistoryOrderDetails.rejected, (state, action) => {
        state.orderHistory = {}
      })
      .addCase(fetchOffHireData.rejected, (state, action) => {
        state.offHireData = null
      })
      .addCase(fetchOffHireData.pending, (state, action) => {
        state.offHireData = null
      })
      .addCase(fetchOffHireData.fulfilled, (state, action) => {
        state.offHireData = action.payload
      })
      .addCase(fetchFuelList.fulfilled, (state, action) => {
        // console.log(action.payload)
        state.fuelList = action.payload
      })
      .addCase(fetchFuelList.rejected, (state, action) => {
        state.fuelList = null
      })
      .addCase(fetchFuelList.pending, (state, action) => {
        state.fuelList = null
      })
      .addCase(fetchFreemiumReportData.fulfilled, (state, action) => {
        const localReports = Array.isArray(state.freemiumReportData)
          ? state.freemiumReportData.filter((item) => item?._local)
          : [];
 
        const serverReports = Array.isArray(action.payload) ? action.payload : [];
 
        const merged = [
          ...serverReports,
          ...localReports.filter(
            (localItem) => !serverReports.some((serverItem) => isSameFreemiumReport(localItem, serverItem))
          )
        ];
 
        state.freemiumReportData = merged;
      })
      .addCase(fetchFreemiumReportData.rejected, (state, action) => {
        state.freemiumReportData = Array.isArray(state.freemiumReportData)
          ? state.freemiumReportData
          : []
      })
      .addCase(fetchFreemiumReportData.pending, (state, action) => {
        state.freemiumReportData = Array.isArray(state.freemiumReportData)
          ? state.freemiumReportData
          : []
      })
.addCase(postEuaCalculateRequest.fulfilled, (state, action) => {
  const report = action.payload; 
  const requestPayload = action.meta?.arg || {};
 
  if (!report) return;
 
  const createdAt = report?.created_at || new Date().toISOString();
  const imoNumber = pickFirstNonEmpty(
    report?.imo_number,
    requestPayload?.imo_number
  );
  const vesselName = pickFirstNonEmpty(
    report?.vessel_name,
    requestPayload?.vessel_name
  );
  const startDate = pickFirstNonEmpty(
    report?.voyage_start_date,
    requestPayload?.voyage_start_date
  );
  const endDate = pickFirstNonEmpty(
    report?.voyage_end_date,
    requestPayload?.voyage_end_date
  );
 
 const localReport = {
  ...report, 
  
  imo_number: imoNumber,
  vessel_name: vesselName,
  voyage_start_date: startDate,
  voyage_end_date: endDate,
  from_port: pickFirstNonEmpty(report?.from_port, requestPayload?.from_port),
  to_port: pickFirstNonEmpty(report?.to_port, requestPayload?.to_port),
  
  vessel_type: report?.vessel_type || requestPayload?.vessel_type,
  
  is_ice_class: report?.is_ice_class ?? requestPayload?.is_ice_class,
  ice_class_type: report?.ice_class_type || requestPayload?.ice_class_type,
  ice_class_distance: report?.ice_class_distance ?? requestPayload?.ice_class_distance,
  
  created_at: createdAt,
  status: 'ready',
  _local: true,
  _local_id: `${imoNumber || 'report'}-${createdAt}`,
};
 
  state.freemiumReportData = Array.isArray(state.freemiumReportData)
    ? [localReport, ...state.freemiumReportData]
    : [localReport];
})
      .addCase(getFuelMetaData.fulfilled, (state, action) => {
        state.fuelMetaData = action.payload
      })
      .addCase(getFuelMetaData.rejected, (state, action) => {
        state.fuelMetaData = {}
      })
      .addCase(getFuelMetaData.pending, (state, action) => {
        state.fuelMetaData = {}
      })
      .addCase(postFuelBlendEstimation.fulfilled, (state, action) => {
        state.blendFactor = action.payload
      })
      .addCase(postFuelBlendEstimation.rejected, (state, action) => {
        state.blendFactor = {}
      })
      .addCase(postFuelBlendEstimation.pending, (state, action) => {
        state.blendFactor = {}
      })
  },
});
 
export const { selectVoyage, clearVoyages } = VoyageSlice.actions
 
export default VoyageSlice.reducer;
 
 